// eslint-disable-next-line
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isBoolean = (value: any) => {
    return typeof value === 'boolean';
};

export default isBoolean;
